import React from 'react';
import PropTypes from 'prop-types';
import { H6 } from '@contently/toolkit';
import { useResource } from 'rest-hooks';
import ContentResource from '../../resources/ContentResource';
import TextEditor from './TextEditor';

export default function HeadlineTextEditor({ storyId, historyMode, readOnlyMode }) {
  const storyContents = useResource(ContentResource.listShape(), { contentable_id: storyId });
  const headline = storyContents.find(c => c.format === 'headline');

  return (
    <React.Fragment>
      <H6>Headline</H6>
      {headline && (
        <TextEditor
          storyId={storyId}
          contentEditorId={headline.uuid}
          contentId={parseInt(headline.id, 10)}
          historyMode={historyMode}
          readOnlyMode={readOnlyMode}
          format="headline"
        />
      )}
    </React.Fragment>
  );
}

HeadlineTextEditor.defaultProps = {
  historyMode: false,
  readOnlyMode: false
};

HeadlineTextEditor.propTypes = {
  storyId: PropTypes.number.isRequired,
  historyMode: PropTypes.bool,
  readOnlyMode: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/HeadlineTextEditor.jsx